/** Field name → the validation message to show under it. */
export type FieldErrors = Partial<Record<string, string>>

/**
 * The field a save-time validation message concerns, read from its prefix:
 * `row.targetPath: …` (the row's schema) or `targetPath: …` (the mapping rules).
 * Nested paths (`row.ruleParams.axis`) are reported on their top-level field.
 */
export function fieldErrorOf(message: string): FieldErrors {
	const match = /^(?:row\.)?([A-Za-z]+)(?:\.[\w.]+)?:\s+(.+)$/s.exec(message.trim())
	if (!match?.[1] || !match[2]) return {}
	return { [match[1]]: match[2] }
}
